import React, { useEffect, useState } from 'react';
import { Image, message } from 'antd';
import { useCookies } from 'react-cookie';
import { theme } from 'utils/style/theme';
import {
  fetchDesignTypeList,
  platformImageDelete,
  platformImageList,
} from 'apis/operation/platformImageApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import MainTable from 'components/table/MainTable';
import NoImage from 'components/etc/NoImage';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import PlatformImgRegisterModal from './PlatformImgRegisterModal';
import PlatformImgLiveDeployModal from './PlatformImgLiveDeployModal';
import PlatformImgZipUploadModal from './PlatformImgZipUploadModal';
import PlatformImgUpdateModal from './PlatformImgUpdateModal';
import DefaultButton from 'components/button/DefaultButton';
import DefaultSelect from 'components/select/DefaultSelect';
import TextButton from 'components/button/TextButton';
import { useTranslation } from 'react-i18next';
/**
 * * 운영 관리 - 플랫폼 이미지 목록
 */

const PlatformImageListPage = () => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  // console.log(cookies);

  const { managementAuth } = cookies;

  const [searchData, setSearchData] = useState();
  const [selectDesignType, setSelectDesignType] = useState('notice_banner');
  const [visible, setVisible] = useState({
    register: false,
    zip: false,
    deploy: false,
    update: false,
  }); // 모달 on-off
  const [datas, setDatas] = useState();
  const [designTypeDropList, setDesignTypeDropList] = useState();
  const [record, setRecord] = useState();

  /// 모달 열기
  const handleOpen = (record) => (e) => {
    setVisible({ ...visible, [e.target.name]: true });
    setRecord(record);
  };

  /// 검색 - 타입 드롭다운
  const handleChangeDesignType = (value) => {
    setSelectDesignType(value);
  };

  /// 이미지 삭제
  const handleDelete = (record) => async () => {
    await platformImageDelete(record.design_id);
    fetchData();
    message.success(t('platformimg.table.deleteSuccessMessage'), 1);
  };

  /// 데이터 불러오기
  const fetchData = async (value) => {
    const res = await platformImageList(value ? value : selectDesignType);
    setDatas(res);
  };
  const fetchDropdownData = async () => {
    const resDesgin = await fetchDesignTypeList();
    setDesignTypeDropList(resDesgin);
  };

  const columnsOrigin = [
    {
      title: t('platformimg.table.image'),
      dataIndex: 'image_url',
      width: '5rem',
      render: (text, record) =>
        record.image_url === null || record.image_url === '' ? (
          <NoImage />
        ) : (
          <Image
            src={record.image_url}
            alt={record.image_name}
            height={40}
            style={{ objectFit: 'contain' }}
          />
        ),
    },
    {
      title: 'ID',
      dataIndex: 'design_id',
      key: 'design_id',
      width: '5rem',
      sorter: (a, b) => a.design_id - b.design_id,
      render: (text, record) => (
        <TextButton
          name='update'
          onClick={handleOpen(record)}
          disabled={JSON.parse(managementAuth)}
        >
          {text}
        </TextButton>
      ),
    },
    {
      title: t('platformimg.table.imageName'),
      dataIndex: 'image_name',
      width: '30rem',
      sorter: (a, b) =>
        a.image_name.localeCompare(b.image_name, undefined, {
          sensitivity: 'base',
        }),
      render: (text, record) => (
        <TextButton
          name='update'
          onClick={handleOpen(record)}
          disabled={JSON.parse(managementAuth)}
        >
          {text}
        </TextButton>
      ),
    },
    {
      title: t('platformimg.table.action'),
      dataIndex: 'move',
      width: '5rem',
      render: (text, record) => (
        <div className='button_in_table'>
          {/* <CapsuleButton
            name="update"
            onClick={handleOpen(record)}
            disabled={JSON.parse(managementAuth)}
          >
            수정
          </CapsuleButton> */}
          <DeletePopConfirm
            title={t('platformimg.table.deleteMessage')}
            onConfirm={handleDelete(record)}
            disabled={JSON.parse(managementAuth)}
          />
        </div>
      ),
    },
  ];
  useEffect(() => {
    fetchDropdownData().catch(console.log);
    fetchData().catch(console.log);
  }, [selectDesignType]);
  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <div>
            <DefaultSelect
              style={{ marginRight: '1rem' }}
              optionList={designTypeDropList}
              value={selectDesignType}
              onChange={handleChangeDesignType}
              width='12rem'
            />
            <SearchInput
              placeholder={t('platformimg.header.inputPlaceHolder')}
              setSearchData={setSearchData}
            />
          </div>
          <div>
            <DefaultButton
              name='register'
              onClick={handleOpen()}
              disabled={JSON.parse(managementAuth)}
            >
              {t('platformimg.header.imageRegistration')}
            </DefaultButton>
            <DefaultButton
              name='zip'
              onClick={handleOpen()}
              disabled={JSON.parse(managementAuth)}
              backColor={`${theme.colors.sub}`}
            >
              {t('platformimg.header.uploadAtOnce')}
            </DefaultButton>
            <DefaultButton
              name='deploy'
              onClick={handleOpen()}
              disabled={JSON.parse(managementAuth)}
              backColor={`${theme.colors.server_orange}`}
            >
              {t('platformimg.header.liveDistribution')}
            </DefaultButton>
          </div>
        </TableToolbar>
        <MainTable
          columns={columnsOrigin}
          dataSource={
            searchData
              ? datas?.filter((v) => v.image_name.indexOf(searchData) !== -1)
              : datas
          }
        />
      </DefaultLayout>
      {/* 모달 모음 */}
      {visible.register && (
        <PlatformImgRegisterModal
          optionList={designTypeDropList}
          selectDesignType={selectDesignType}
          setSelectDesignType={setSelectDesignType}
          visible={visible.register}
          setVisible={setVisible}
          fetchData={fetchData}
        />
      )}
      {visible.deploy && (
        <PlatformImgLiveDeployModal
          visible={visible.deploy}
          setVisible={setVisible}
        />
      )}
      {visible.zip && (
        <PlatformImgZipUploadModal
          optionList={designTypeDropList}
          selectDesignType={selectDesignType}
          setSelectDesignType={setSelectDesignType}
          visible={visible.zip}
          setVisible={setVisible}
          fetchData={fetchData}
        />
      )}
      {visible.update && (
        <PlatformImgUpdateModal
          optionList={designTypeDropList}
          setSelectDesignType={setSelectDesignType}
          visible={visible.update}
          setVisible={setVisible}
          fetchData={fetchData}
          record={record}
        />
      )}
    </>
  );
};

export default PlatformImageListPage;
